<template>
  <v-card class="delivery-address">
    <v-card-title class="text-h5 grey lighten-2" primary-title>
      <span v-if="getIsGift" key="gift-delivery-details"
        >Confirm the Gift Delivery Details</span
      >
      <span v-else key="reggy-delivery-details"
        >Confirm Your Delivery Details</span
      >
    </v-card-title>
    <v-card-text class="mt-3">
      <template v-if="!getIsGift">
        <h2 v-if="getAuthUserHasAddress"
          >Current Address : <br />{{ currAddress }}</h2
        >
        <template v-else>
          <h2>We don't have your address on file yet!</h2>
          <h3 class="font-italic mb-3">Please enter your details below</h3>
        </template>
      </template>
      <v-form v-model="isFormValid" ref="form">
        <v-switch
          label="Use A Different Address"
          v-model="useDifferentAddress"
          v-if="getAuthUserHasAddress && !getIsGift"
        />
        <div v-if="showAddressForm" outlined class="mb-3">
          <v-text-field
            :rules="[rules.required]"
            label="Street Address"
            v-model="street"
            autofocus
          />
          <v-text-field label="Apartment / Suite" v-model="apt" />
          <v-text-field :rules="[rules.required]" label="City" v-model="city" />
          <v-text-field
            :rules="[rules.required, rules.zipcode]"
            label="Zip"
            v-model="zip"
          />
          <v-checkbox
            v-if="!getIsGift"
            label="Save this as my default address"
            v-model="saveAsDefault"
          />
        </div>
        <v-textarea
          hint="Special Request/Delivery Instructions?"
          persistent-hint
          rows="2"
          v-model="specialInstrux"
          outlined
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-2 white--text"
        @click="confirmAndOrder"
        depressed
        :disabled="!isFormValid"
        :loading="loading"
      >
        Confirm &amp; {{ $mq !== 'xs' ? 'Pre-' : '' }}Order
      </v-btn>
      <v-btn color="deep-orange" outlined @click="$emit('close')">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import ValidationRules from '@/constants/ValidationRules'

export default {
  name: 'DeliveryDetails',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('customer', ['updateCustomer', 'updateSelf']),
    async confirmAndOrder() {
      if (this.saveAsDefault) {
        let newAddy = [this.street, this.apt, this.city]
          .filter((i) => i.trim().length)
          .join(' | ')
        await this.updateSelf({
          data: { street: newAddy, zip: this.zip },
        })
      }
      this.deliveryAddress = await this.currAddress
      await this.$emit('orderConfirmed')
    }, // submitOrddr
  },
  computed: {
    ...mapFields('cart', ['specialInstrux', 'deliveryAddress']),
    ...mapGetters('cart', ['getIsGift']),
    ...mapGetters('customer', ['getCustomer', 'getCustomerAddress']),
    ...mapGetters('auth', [
      'getAuthUserHasAddress',
      'getAuthUserAddress',
      'getAuthUserStreetAddress',
      'getAuthUserZip',
    ]),
    currAddress() {
      if (!this.showAddressForm) {
        return this.getAuthUserAddress
      }
      let newAddy = [this.street, this.apt, this.city, this.zip]
        .filter((i) => i.trim().length)
        .join(', ')
      return newAddy.length ? newAddy : this.getAuthUserAddress
    }, // currAddress
    showAddressForm: {
      get() {
        return (
          !this.getAuthUserHasAddress ||
          this.useDifferentAddress ||
          this.getIsGift
        )
      },
      set() {
        // nada
      },
    }, // showAddressForm
    rules() {
      return {
        required: (v) => {
          if (!this.useDifferentAddress) return true
          return ValidationRules.requiredString(v)
        },
        zipcode: (v) => {
          if (!this.useDifferentAddress) return true
          return ValidationRules.zipRule(v)
        },
      }
    },
  },
  data() {
    return {
      useDifferentAddress: false,
      isFormValid: false,
      street: '',
      apt: '',
      city: '',
      zip: '',
      saveAsDefault: false,
    }
  },
  created() {
    if (!this.getAuthUserHasAddress && !this.getIsGift) {
      this.saveAsDefault = true
    }
  },
  watch: {
    showAddressForm: {
      handler(val) {
        this.useDifferentAddress = val
      },
      immediate: true,
    },
    currAddress: {
      handler(val) {
        this.deliveryAddress = val
      },
    },
  },
}
</script>

<style lang="css" scoped>
.v-card__title {
  word-break: break-word;
}
</style>
